import { Routes } from '@angular/router';

export const LOCALE_ROUTES: Routes = [
  {
    path: 'channels/locales/view-edit/:localeId',
    loadComponent: () =>
      import('./locale-view-edit/locale-view-edit.component').then(
        (com) => com.LocaleViewEditComponent
      ),
    title: 'View/Edit Locale',
  },
  {
    path: 'channels/locales/add',
    loadComponent: () =>
      import('./locale-add/locale-add.component').then(
        (com) => com.LocaleAddComponent
      ),
    title: 'Add Locale',
  },
];
